import { createSelector } from 'reselect'

const getEmailTemplates = (state: any) => state.email

const getBasicEmailTemplate = (state: any) => state.email

/** A Redux selector to retrieve Email Templates Data
 * @param state - The Redux state
 * @param {Array} - Email Templates Data.
 */

export const selectEmailTemplatesList = createSelector(
  getEmailTemplates,
  (data) => data && data.emailTemplates && data.emailTemplates.email ? data.emailTemplates.email : null
)

/** A Redux selector to retrieve Email Templates Total Data
 * @param state - The Redux state
 * @param {Number} - Email Templates Total Data.
 */

export const selectEmailTemplatesListTotal = createSelector(
  getEmailTemplates,
  (data) => data && data.emailTemplates && data.emailTemplates.total ? data.emailTemplates.total : 0
)

/** A Redux selector to retrieve Email Templates loading
 * @param state - The Redux state
 * @param {Boolean} - Email Templates loading.
 */

export const selectEmailTemplatesListIsLoading = createSelector(
  getEmailTemplates,
  (data) => data && data.emailTemplates && data.emailTemplates.status ? data.emailTemplates.status.inProgress : false
)

/** A Redux selector to retrieve Get Template data
 * @param state - The Redux state
 * @param {object} - Get Template data.
 */

export const selectEmailTemplate = createSelector(
  getEmailTemplates,
  (data) => data && data.getTemplate && data.getTemplate.data ? data.getTemplate.data : null
)

/** A Redux selector to retrieve Get Basic Template data
 * @param state - The Redux state
 * @param {object} - Get Basic Template.
 */

export const selectBasicEmailTemplate = createSelector(
  getBasicEmailTemplate,
  (data) => data && data.getBasicTemplate && data.getBasicTemplate.data ? data.getBasicTemplate.data : null
)

/** A Redux selector to retrieve Create Template status
 * @param state - The Redux state
 * @param {string} - Create Template status.
 */

export const selectCreateTemplateStatus = createSelector(
  getEmailTemplates,
  (data) => data && data.createTemplate && data.createTemplate.status ? data.createTemplate.status : null
)

/** A Redux selector to retrieve Create Template Email id
 * @param state - The Redux state
 * @param {string} - Create Template Email id.
 */

export const selectCreateTemplateEmailId = createSelector(
  getEmailTemplates,
  (data) => data && data.createTemplate && data.createTemplate.id ? data.createTemplate.id : null
)

/** A Redux selector to retrieve Deactivate Template loading
 * @param state - The Redux state
 * @param {Boolean} - Deactivate Template loading.
 */

export const selectDeactivateTemplateIsLoading = createSelector(
  getEmailTemplates,
  (data) => data && data.deactivateTemplate && data.deactivateTemplate.inProgress ? data.deactivateTemplate.inProgress : false
)

/** A Redux selector to retrieve Activate Template loading
 * @param state - The Redux state
 * @param {Boolean} - Activate Template loading.
 */

export const selectActivateTemplateIsLoading = createSelector(
  getEmailTemplates,
  (data) => data && data.activateTemplate && data.activateTemplate.inProgress ? data.activateTemplate.inProgress : false
)

/** A Redux selector to retrieve Delete Template loading
 * @param state - The Redux state
 * @param {Boolean} - Delete Template loading.
 */

export const selectDeleteTemplateIsLoading = createSelector(
  getEmailTemplates,
  (data) => data && data.deleteTemplate && data.deleteTemplate.inProgress ? data.deleteTemplate.inProgress : false
)

/** A Redux selector to retrieve Update Template status
 * @param state - The Redux state
 * @param {string} - Update Template status.
 */

export const selectUpdateTemplateStatus = createSelector(
  getEmailTemplates,
  (data) => data && data.updateTemplate && data.updateTemplate.status ? data.updateTemplate.status : null
)

/** A Redux selector to retrieve Send Preview Template status
 * @param state - The Redux state
 * @param {string} - Send Preview Template status.
 */

export const selectSendTemplateStatus = createSelector(
  getEmailTemplates,
  (data) => data && data.sendPreview && data.sendPreview.status ? data.sendPreview.status : null
)

/** A Redux selector to retrieve Send Preview Template response
 * @param state - The Redux state
 * @param {string} - Send Preview Template response.
 */

export const selectSendTemplateResponse = createSelector(
  getEmailTemplates,
  (data) => data && data.sendPreview && data.sendPreview.response ? data.sendPreview.response : null
)

/** A Redux selector to retrieve Get Preview Template data
 * @param state - The Redux state
 * @param {object} - Get Preview Template data.
 */

export const selectEmailPreviewTemplate = createSelector(
  getEmailTemplates,
  (data) => data && data.getPreviewTemplate && data.getPreviewTemplate.data ? data.getPreviewTemplate.data : null
)

/** A Redux selector to retrieve Email Types Data
 * @param state - The Redux state
 * @param {Array} - Email Types Data.
 */

 export const selectEmailTypesList = createSelector(
  getEmailTemplates,
  (data) => data && data.emailTypes && data.emailTypes.email ? data.emailTypes.email : null
)
